import { LEAD_DROP_POPUP_1_CONSTANTS } from "./leadDropPopup_1";

/** Lead drop popup variant 3 — “Drop a query” style (name, official email, phone, details + OTP) */
export const LEAD_DROP_POPUP_3_CONSTANTS = {
  DEFAULT_ROW: {
    ...LEAD_DROP_POPUP_1_CONSTANTS.DEFAULT_ROW,
    form_title: "Drop a Query",
    form_sub_text:
      "Fill out the form below and our team will get back to you shortly.",
    signup_button_text: "Submit",
    button_color: "#8E7CC3",
    checkbox_color: "#8E7CC3",
    edit_text_color: "#8E7CC3",
    resend_text_color: "#8E7CC3",
    new_user_title: "Thank you!",
    new_user_description: "Our team will get back to you shortly.",
  },
  LEAD_DROP_POPUP_FIELDS_CONFIG:
    LEAD_DROP_POPUP_1_CONSTANTS.LEAD_DROP_POPUP_FIELDS_CONFIG,
  METADATA_FIELDS: [],
};
